import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { QrCode, Send, ArrowRight } from "lucide-react";
import { DashLayout } from "@/components/DashLayout";
import { WalletCards } from "@/components/WalletCards";
import { TxTable } from "@/components/Tables";
import { DashboardCharts } from "@/components/DashboardCharts";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { USER_NAV } from "@/pages/navs";

export default function UserOverview() {
  const { user, refresh, tick } = useAuth();
  const [txns, setTxns] = useState([]);

  useEffect(() => { refresh(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    api.get("/me/transactions", { params: { limit: 8 } }).then((r) => setTxns(r.data));
  }, [tick]);

  return (
    <DashLayout nav={USER_NAV} title={`Welcome, ${user?.name || ""}`} subtitle={user?.business_name}>
      <WalletCards user={user} />
      <div className="grid gap-4 md:grid-cols-2">
        <Link to="/dashboard/qr" data-testid="quick-static-qr" className="group flex items-center gap-4 rounded-xl bg-[#0A1F44] p-5 text-white transition-transform hover:-translate-y-0.5">
          <span className="grid h-11 w-11 place-items-center rounded-lg bg-white/10"><QrCode className="h-5 w-5" /></span>
          <div className="flex-1"><div className="font-display font-semibold">Static QR</div><div className="text-sm text-slate-300">View your QR, UPI ID and pay link</div></div>
          <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
        </Link>
        <Link to="/dashboard/payouts" data-testid="quick-payout" className="group flex items-center gap-4 rounded-xl bg-[#2563EB] p-5 text-white transition-transform hover:-translate-y-0.5">
          <span className="grid h-11 w-11 place-items-center rounded-lg bg-white/15"><Send className="h-5 w-5" /></span>
          <div className="flex-1"><div className="font-display font-semibold">Request Payout</div><div className="text-sm text-blue-100">Withdraw from payout wallet to bank</div></div>
          <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
        </Link>
      </div>
      <DashboardCharts />
      <div>
        <div className="mb-3 flex items-center justify-between">
          <h2 className="font-display text-lg font-semibold text-[#0A1F44]">Recent transactions</h2>
          <Link to="/dashboard/transactions" className="text-sm font-semibold text-[#2563EB]" data-testid="view-all-txns">View all</Link>
        </div>
        <TxTable rows={txns} />
      </div>
    </DashLayout>
  );
}
